import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Separator } from '../components/ui/separator';
import { ChevronRight, CreditCard, ShieldCheck, Truck, ArrowLeft } from 'lucide-react';

export const CheckoutPage: React.FC = () => {
  return (
    <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-6 md:py-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
        <div className="space-y-2">
          <h1 className="text-3xl md:text-5xl font-black tracking-tight text-[#111418] dark:text-white uppercase leading-none">Checkout</h1>
          <p className="text-gray-500 font-medium tracking-tight">Finalize your premium selection and secure your delivery.</p>
        </div>
        <Link to="/cart" className="text-sm font-bold text-primary flex items-center gap-2 hover:gap-3 transition-all mb-1">
          <ArrowLeft className="size-4" /> Return to Bag
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16">
        <div className="lg:col-span-8 space-y-12">
          {/* Section 1: Shipping */}
          <section className="space-y-6">
            <div className="flex items-center gap-3">
              <div className="size-8 bg-[#111418] dark:bg-white text-white dark:text-black flex items-center justify-center rounded-full font-black text-xs">1</div>
              <h2 className="text-xl font-black tracking-tight text-[#111418] dark:text-white uppercase">Shipping Information</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-1.5">
                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 px-1">First Name</label>
                <div className="h-12 bg-gray-50 dark:bg-gray-900 rounded-2xl border border-border/40 w-full animate-pulse"></div>
              </div>
              <div className="space-y-1.5">
                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 px-1">Last Name</label>
                <div className="h-12 bg-gray-50 dark:bg-gray-900 rounded-2xl border border-border/40 w-full animate-pulse"></div>
              </div>
              <div className="md:col-span-2 space-y-1.5">
                <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 px-1">Address Line 1</label>
                <div className="h-12 bg-gray-50 dark:bg-gray-900 rounded-2xl border border-border/40 w-full animate-pulse"></div>
              </div>
            </div>
          </section>

          <Separator className="opacity-50" />

          {/* Section 2: Payment */}
          <section className="space-y-6">
            <div className="flex items-center gap-3">
              <div className="size-8 bg-[#111418] dark:bg-white text-white dark:text-black flex items-center justify-center rounded-full font-black text-xs">2</div>
              <h2 className="text-xl font-black tracking-tight text-[#111418] dark:text-white uppercase">Secure Payment</h2>
            </div>
            <div className="p-8 bg-gray-50 dark:bg-gray-900 rounded-[2rem] border border-border/40 flex flex-col items-center justify-center text-center space-y-4">
              <div className="size-16 bg-white dark:bg-black rounded-[1.5rem] flex items-center justify-center shadow-sm">
                <CreditCard className="size-6 text-primary" />
              </div>
              <div className="space-y-1">
                <p className="font-black text-[#111418] dark:text-white tracking-tight">Payment Integration Ready</p>
                <p className="text-xs text-gray-500 font-medium max-w-xs">Securely process your transaction using industry standard protocols.</p>
              </div>
              <Button disabled className="rounded-xl font-black text-xs py-5 px-8">Enable Provider</Button>
            </div>
          </section>
        </div>

        {/* Sidebar Summary */}
        <div className="lg:col-span-4">
          <div className="bg-[#111418] text-white rounded-[2.5rem] p-8 md:p-10 space-y-8 sticky top-24 shadow-2xl">
            <h2 className="text-2xl font-black tracking-tight uppercase">Order Details</h2>

            <div className="space-y-4">
              <div className="flex justify-between items-center text-sm font-bold">
                <span className="text-gray-400">Items (2)</span>
                <span>$479.98</span>
              </div>
              <div className="flex justify-between items-center text-sm font-bold">
                <span className="text-gray-400">Global Shipping</span>
                <span className="text-emerald-400 uppercase tracking-widest text-[10px]">Complimentary</span>
              </div>
              <Separator className="bg-white/10" />
              <div className="flex justify-between items-center">
                <span className="text-lg font-black uppercase">Total</span>
                <span className="text-2xl font-black text-primary">$479.98</span>
              </div>
            </div>

            <Button className="w-full h-16 rounded-2xl text-base font-black shadow-2xl shadow-primary/20 transition-all hover:-translate-y-1 bg-primary hover:bg-primary/90 text-white gap-2 border-0">
              Confirm Order <ShieldCheck className="size-5" />
            </Button>

            <div className="space-y-4 pt-4 border-t border-white/5">
              <div className="flex items-center gap-3">
                <div className="size-8 rounded-full bg-white/5 flex items-center justify-center">
                  <Truck className="size-4 text-gray-400" />
                </div>
                <div className="flex flex-col">
                  <span className="text-[10px] font-black uppercase tracking-widest">Premium Express</span>
                  <span className="text-[10px] text-gray-500">Delivered within 48 hours</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
